<div class="layout-wrapper" [ngClass]="{'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple,
        'layout-static': isStatic(),
        'layout-overlay': isOverlay(),
        'layout-overlay-active': overlayMenuActive && isOverlay(),
        'layout-horizontal': isHorizontal(),
        'layout-static-active': !staticMenuDesktopInactive && isStatic(),
        'layout-mobile-active': staticMenuMobileActive,
        'layout-rtl': app.isRTL,
        'layout-rightpanel-active': rightPanelActive}"   
    [class]="'layout-menu-'+ app.menuTheme+ ' layout-topbar-'+ app.topbarTheme" id="cozmosAppMain">

     <!-- *ngIf="!router?.url.includes('document-viewer')" -->
    <ng-container *ngIf="isLoadContent else loading">
        <app-topbar></app-topbar>
        <div class="menu-wrapper" (click)="onMenuClick($event)" id="menuWrapper">
            <div class="layout-menu-container" >
                <app-menu></app-menu>
            </div>
        </div>
        <!-- [ngClass]="!router?.url.includes('document-viewer')?'layout-main':'layout-main layout-main-full'" -->
        <div  [ngClass]="'layout-main'" >
            <div  [ngClass]="true?'layout-content':'layout-content layout-content-full'" >  
                <p-breadcrumb [model]="items" [home]="home" *ngIf="!(router?.url?.includes('search/application') ||router?.url?.includes('search/document-grid') || router?.url?.includes('search/document-viewer'))">
                    <ng-template #item let-item>
                            <span>item.label</span>
                    </ng-template>
                    <ng-template #separator> / </ng-template>
                </p-breadcrumb>
                    <router-outlet></router-outlet>  
            </div>
        </div>
    </ng-container>
    <app-footer ></app-footer>
    <ng-template #loading>
        <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </section>
    </ng-template>

    <!-- <app-config></app-config> -->
<div *ngIf="staticMenuMobileActive" class="layout-mask modal-in"></div>
</div>
